import styles from "./styles.module.css";
import Toggle from "./toggle";
import NameEdit from "./nameeditor";
import DangerZone from "./dangerzone";
import { useState, useContext, useEffect } from "react";
import { EditorValue, EditorDisbatch } from "../../../contexts/editor";
import { PageDisbatch } from "../../../contexts/page";
import { TypesValue } from "../../../contexts/types";
import useStateTypes from "../../../utils/usestatetypes";
import Actions from "./events";
import Props from "./props";
import CustomProps from "./customprops";
import CustomEvents from "./customevents";
import StateVariables from "./statevariables";
import Conditional from "./conditional";
export default function Editor({ open, setWorkflows }) {
  const [toggle, setToggle] = useState("props");
  const editor = useContext(EditorValue);
  const editorDisbatch = useContext(EditorDisbatch);
  const pageDisbatch = useContext(PageDisbatch);
  const types = useContext(TypesValue);
  const stateTypes = useStateTypes();

  const setName = (value) => {
    const newBlock = { ...editor.block };
    newBlock.name = value;
    pageDisbatch({ type: "replace", block: newBlock, path: editor.path });
    editorDisbatch({
      type: "set",
      value: { block: newBlock, path: editor.path },
    });
  };

  const deleteBlock = () => {
    pageDisbatch({ type: "remove", block: editor.block, path: editor.path });
    editorDisbatch({
      type: "set",
      value: null,
    });
  };

  const onChange = (block) => {
    pageDisbatch({ type: "replace", block, path: editor.path });
    editorDisbatch({
      type: "set",
      value: { block, path: editor.path },
    });
  };

  if (!editor) {
    return (
      <div
        style={{
          backgroundColor: "white",
          margin: "10px 10px 10px 0px",
          overflowY: "scroll",
          borderRadius: 8,
          zIndex: 10,
          boxSizing: "border-box",
          boxShadow: "var(--shadow)",
          display: "flex",
          flexDirection: "column",
        }}
        className={open ? styles.open : styles.close}
      >
        <div
          style={{
            padding: 30,
            marginTop: 80,
            width: 300,
            boxSizing: "border-box",
          }}
        >
          <h4 style={{ textAlign: "center" }}>
            {" "}
            Select an element to edit its properties
          </h4>
        </div>
      </div>
    );
  }

  return (
    <TypesValue.Provider value={[...types, ...stateTypes]}>
      <div
        style={{
          backgroundColor: "white",
          margin: "10px 10px 10px 0px",
          overflowY: "scroll",
          borderRadius: 8,
          zIndex: 10,
          boxSizing: "border-box",
          boxShadow: "var(--shadow)",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
        className={open ? styles.open : styles.close}
      >
        <div>
          <NameEdit setName={setName} name={editor.block.name} />
          <Toggle toggle={{ value: toggle, set: setToggle }} />
          {toggle === "props" ? (
            <>
              {editor.block.component === "Component" && (
                <>
                  <CustomProps
                    block={editor.block}
                    onChange={onChange}
                    path={editor.path}
                  />
                  <CustomEvents
                    block={editor.block}
                    onChange={onChange}
                    path={editor.path}
                  />
                </>
              )}

              <Props
                block={editor.block}
                onChange={onChange}
                path={editor.path}
              />

              <DangerZone
                editorDisbatch={editorDisbatch}
                block={editor.block}
                deleteBlock={deleteBlock}
              />
            </>
          ) : toggle === "conditions" ? (
            <Conditional
              block={editor.block}
              path={editor.path}
              onChange={onChange}
            />
          ) : (
            <Actions
              block={editor.block}
              onChange={onChange}
              path={editor.path}
              setWorkflows={setWorkflows}
            />
          )}
        </div>
      </div>
    </TypesValue.Provider>
  );
}
